export enum RecordCreateModalLocation {
	DASHBOARD,
	SEQUENCES,
	MEASUREMENT_GOALS,
	DEVICES,
	CLEARANCES
}
